import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    statusGetTradeNameConfResponse: null,
    statusSetTradeNameConfResponse: null,
    tradeName: [],
    tradeNameConfigMessage: '',
    listClients: [],
  },
  mutations: {
    setListClients (state, data) {
      state.listClients = data
    },
    setTradeName (state, data) {
      state.tradeName = data
    },
    setResponseUpdateTradeNameConfig (state, data) {
      state.statusSetTradeNameConfResponse = data
    },
    setResponseGetTradeName (state, data) {
      state.statusGetTradeNameConfResponse = data
    },
    setResponseTradeNameConfigMsg (state, data) {
      state.tradeNameConfigMessage = data
    },
  },
  actions: {
    getListClients ({ commit }) {
      const endpoint = '/api/getClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListClients', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getTradeNameConfig ({ commit }, data) {
      let params = 'IdCompania=' + -1
      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        console.log(JSON.parse(atob(localStorage.getItem('uid'))).rol.trim);
        console.log('Desarrollador');

        params = 'IdCompania=' + JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      } else {
        params = 'IdCompania=' + data.IdCompania
      }

      const endpoint = '/api/getTradeNameConfig?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
            commit('setTradeName', response.data.Data)
          if (response.data.Error) {
            commit('setResponseGetTradeName', true)
            commit('setResponseTradeNameConfigMsg', 'Hubo un error obteniendo la configuración. Intentelo nuevamente.')
          } else {
            commit('setResponseGetTradeName', false)
            commit('setResponseTradeNameConfigMsg', 'Configuración consultada exitosamente.')
          }
        })
        .catch(function (error) {
          commit('setResponseGetTradeName', true)
          commit('setResponseTradeNameConfigMsg', 'No pudo obtener configuración . Intentelo nuevamente.')
          console.log(error.message)
        })
    },
    updateTradeNameConfig ({ commit }, data) {
      const endpoint = '/api/updateTradeNameConfig'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        data.IdCompania = JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      }

      axios
        .create()
        .put(url, data)
        .then(response => {
          console.log(response)
            if (response.data.Error) {
              commit('setResponseUpdateTradeNameConfig', true)
              commit('setResponseTradeNameConfigMsg', 'Hubo un error guardando la configuración. Intentelo nuevamente.')
            } else {
              commit('setResponseUpdateTradeNameConfig', false)
              commit('setResponseTradeNameConfigMsg', 'Configuración guardada exitosamente.')
            }
        })
        .catch(function (error) {
          commit('setResponseUpdateTradeNameConfig', true)
          commit('setResponseTradeNameConfigMsg', 'No pudo obtener información de la configuración.')
          console.log(error.message)
        })
    },
    setUpdateStatusResponse ({ commit }, data) {
      commit('setResponseUpdateTradeNameConfig', data)
    },
    statusGetTradeNameConfResponse ({ commit }, data) {
      commit('setResponseGetTradeName', data)
    },
  },
}
